import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import MediaSelector from '../../MediaSelector/MediaSelector';
import { useCurrentMediaSource } from '../../_hocs/withCurrentMediaSource';
import { MediaSourceType } from '../../types';
import { DeviationResourceType } from '../../../types/deviation';
import { useFilterProps } from '../../_hocs/withFilter';
import innerMediaSelectorStyles from './InnerMediaSelector.scss';
import { useGruser } from '../../_hocs/withGruser';
const InnerMediaSelector = ({ selectionLimit , onSelect , onClose , title , submitBtnLabel  })=>{
    const { currentMediaSource , mediaSourceTypes , withMediaSourceSelector  } = useCurrentMediaSource();
    const { allowedDeviationTypes , allowedDeviationResourceTypes , allowGifs , allowInTierContent , ignoreDeviationIds  } = useFilterProps();
    const { gruser  } = useGruser();
    return /*#__PURE__*/ React.createElement(MediaSelector, _extends({
        gruser: gruser,
        initialMediaSource: currentMediaSource,
        mediaSourceTypes: mediaSourceTypes,
        withMediaSourceSelector: withMediaSourceSelector,
        allowedDeviationTypes: allowedDeviationTypes,
        allowedDeviationResourceTypes: allowedDeviationResourceTypes,
        allowGifs: allowGifs,
        allowInTierContent: currentMediaSource && [
            MediaSourceType.TIER_DEVIATIONS,
            MediaSourceType.TIER_POSTS
        ].includes(currentMediaSource) || allowInTierContent,
        ignoreDeviationIds: ignoreDeviationIds,
        selectionLimit: selectionLimit,
        contentClassName: innerMediaSelectorStyles['content'],
        overlayClassName: innerMediaSelectorStyles['add-deviations-overlay'],
        onSelect: onSelect,
        onClose: onClose,
        title: title,
        submitBtnLabel: submitBtnLabel
    }, {
        [MediaSourceType.CUSTOM_SET]: {
            withMediaSourceSelector: true,
            initialMediaSource: mediaSourceTypes === null || mediaSourceTypes === void 0 ? void 0 : mediaSourceTypes[0]
        },
        [MediaSourceType.TIER_DEVIATIONS]: {
            initialMediaSource: MediaSourceType.GALLERY,
            mediaSourceTypes: [
                MediaSourceType.GALLERY,
                MediaSourceType.TIER_DEVIATIONS
            ],
            withMediaSourceSelector: true,
            allowUploads: false
        },
        [MediaSourceType.TIER_POSTS]: {
            initialMediaSource: MediaSourceType.POSTS,
            mediaSourceTypes: [
                MediaSourceType.POSTS,
                MediaSourceType.TIER_POSTS
            ],
            allowedDeviationResourceTypes: [
                DeviationResourceType.JOURNAL,
                DeviationResourceType.STATUS_DEVIATION
            ],
            withMediaSourceSelector: true,
            allowUploads: false
        }
    }[currentMediaSource !== null && currentMediaSource !== void 0 ? currentMediaSource : '']));
};
InnerMediaSelector.displayName = 'InnerMediaSelector';
export default InnerMediaSelector;
